export const TimeKeepingEN = {
  timekeepingSettings: "Timekeeping Settings",
  timesheetFormula: "Timesheet Formula",
  shiftWork: "Shift Work",
  annualLeave: "Annual Leave",
  setupHoliday: "Setup Holiday",
  tnp: {
    common: {
      auditing: {
        auditing_modal_title: "Activity History",
        auditing_render_history_title: "Changed Values",
        facebook_counter_title: "Interactions",

        column: {
          nameKey: "Field Name",
          oldValue: "Old Value",
          newValue: "New Value",
        },

        toDate: "From Date",
        fromDate: "To Date",
        select: "Select",
        task: "Task",
        rollBack: "Recall",
      },
      document: {
        action: "Upload / Create New",
        menu: {
          checkfilewarning:
            " is editing the file, please wait until the editing process is complete!",
        },
      },
      ellipsis: {
        recall: "Recall",
        more: " See more",
        less: "  See less",
      },
      file: {
        text1: "Management Software",
        text2: "Professional",
        text3: "Simple, convenient, and easy to use",
        text4: "for all businesses",
        text5: "Enter password",
        text6: "Login",
        text7: "Install the app on your phone",
      },
      layout: {
        change: {
          avt: "Update profile picture",
          currentEmail: "Current Email",
          newEmail: "New Email",
          newEmailConfirm: "Confirm New Email",
          currentPass: "Current Password",
          newPass: "New Password",
          newPassConfirm: "Confirm New Password",
        },
        avatar: {
          member: "Member:",
          month: "Months ago",
          year: "Years ago",
          day: "Days ago",
          hour: "Hours ago",
          minute: "Minutes ago",
          second: "Seconds ago",
          count: "Quantity:",
        },
        notification: {
          all: "All",
          noRead: "Unread",
          notNotification: "No notifications",
        },
        list: {
          total: " out",
          message: "Data is being updated",
        },
      },

      text: {
        editText:
          " is editing the file, please wait until the editing process is complete!",
      },
    },
    components: {
      report: {
        filter: "Filters",
        dayToday: "today",
        dayYesterday: "1 day ago",
        oneThisWeek: "This week",
        oneWeekAgo: "1 week ago",
        oneThisMonth: "This month",
        oneMonthAgo: "1 month ago",
        sevenDayAgo: "7 days ago",
        twentyEightDayAgo: "28 days ago",
        ninetyDayAgo: "90 days ago",
        numberDay: "{{count}} day",
        numberDay_plural: "{{count}} days",
        custom: "Custom",
        today: "Today",
        yesterday: "Yesterday",
        thisWeek: "This Week",
        lastWeek: "Last Week",
        todayText: "Today",
        yesterdayText: "Yesterday",
        lastMonth: "Last Month",
        fromDate: "From Date",
        thisMonth: "This Month",
        lateSoonFrequency: "Late/Early Frequency",
        lateSoonMinute: "Late/Early Time",
        totalHour: "Working Time",
        noCheckInOut: "Missed Check-in/Out",
        moneyPenalty: "Penalty Fee",
        totalOvertime: "Overtime Hours",
        missionFrequency: "Business Trip Frequency",
        absenceFrequency: "Leave Frequency",
        overview: "Overview",
        reset: "Reset",
        dateRange: "Date Range",
        selectAll: "Select All",
        customReport: "Report Time Selection",
        quantity: "Quantity",
        totalHourColumn: "Total Hours",
        totalMoney: "Total Amount",
        totalCount: "Total Occurrences",
        timeUnit: "Time (hours)",
        money: "Amount (x 1K VND)",
        timeDay: "Time (days)",
        dayLate: "Day of late ",
        missDay: "Missed day",
        penaltyDay: "Penalty Day",
      },
      application: {
        leave: "Resignation Application",
        shiftChangeType: "Type ",
        lateType: "Type",
        absence: "Mid-shift Absence",
        late: "Late Arrival",
        soon: "Early Departure",
        range: "By Date Range",
        fixed: "By Fixed Date",
        weekly: "Weekly Recurrence",
        shiftChange: "Shift Change",
        shiftMore: "Shift More",
        shiftRegister: "Shift Register",
      },
      process: {
        detail: "Detailed Information",
        totalApplication: "{{count}} approved requests were found, including:",
        apply: "Apply",
        disable: "Disable",
      },
      file: {
        uploadError: "Upload failed",
        uploadMaxFile: "Only one payroll template can be uploaded",
        updateErrorType: "Only excel format XLS, XLSX is supported",
        updateMaxSize: "File size must not exceed 2MB",
      },
      casualLeave: {
        titleUpdateModal: "Edit Direct Leave",
        tooltip: "This action directly modifies leave records",
        month: "By Month",
        year: "By Year",
        warningProcess:
          "The process is in progress, please wait until it is completed!",
        titleModalConfirm: "Confirmation",
        calculateLeaveYear: "Recalculate Annual Leave",
      },
      autoCheckInOut: {
        noData: "No data available",
        confirmRemove:
          "Are you sure you want to delete the automatic timekeeping of",

        titleRow: {
          maNv: "Employee Code",
          employee: "Applicable Object",
          startTime: "From Date",
          endTime: "To Date",
          department: "Department",
          position: "Position",
          title: "Job Title",
          employeeName: "Full Name",
          timeStart: "Start Time",
          timeEnd: "End Time",
        },
        required: {
          employee: "Applicable object is required!",
        },
      },
      shiftAssignment: {
        contentConfirm:
          "To update the new data for the approved shift assignment, the system will change the shift assignment ",
        contentConfirm1: " to the status ",
        contentConfirm2: "Not approved",
        informationText:
          "Shift types include: Office hours or rotating shifts, with priority order as follows: Rotating shifts, public holidays, and office hours. This means rotating shifts take priority over public holidays, and public holidays take priority over office hours.",
        office_hour: "Office hours",
        shift_works: "Rotating shifts",
        assign_department_position: "Assign shifts by department and position",
        assign_personnel: "Assign shifts to individuals",
        leaveBetween: "Break time between shifts",
        tableTitle: "Shift assignment list",
        label: {
          day: "Date",
          department: "Department",
          employee: "Employee",
        },
        required: {
          day: "Date is required!",
          employee: "Employee is required!",
        },
        placeholder: {
          employee: "Select an employee",
        },
        button: {
          create: "Create new shift assignment",
          update: "Update shift assignment",
          titleDelete: "Delete shift assignment",
          titleSalaryDelete: "Delete payroll",
          approval: "Approve",
          recallApproval: "Recall Approval",
          approval1: "Approve Shift",
          recallApproval1: "Recall Shift Approval",
        },
      },
      shiftRegistration: {
        titleModal: "Shift Registration Details",
        titleTableFile: "Attachment List",
        titleList: "Shift Registration List",
        columns: {
          employee: "Employee Name",
          status: "Status",
          createDate: "Creation Date",
          draft: "Draft",
          pending: "Pending",
          doing: "Doing",
          approved: "Approved",
          actived: "Active",
          inactive: "Inactive",
          inactived: "Inactivated",
          denied: "Denied",
        },
      },
      timesheet: {
        T2: "Mon",
        T3: "Tue",
        T4: "Wed",
        T5: "Thu",
        T6: "Fri",
        T7: "Sat",
        CN: "Sun",
        department: "Department",
        jobTitle: "Job Title",
        jobPosition: "Position",
        shiftName: "Shift Name",
        text1: "Work attendance",
        text2: "Employee Information",
        text3: "Edit attendance Directly",
        text4: "Remove Direct attendance and Recalculate",
        text5: "Employee Code",
        text6: " Shift: ",
        text7: "Shift Code",
        text8: "Time",
        text9: "Fingerprint Record",
        text10: "Hours",
        text11: "Calculated Work Hours",
        text12: "Rounded attendance Hours Based on Settings",
        text13: "Leave",
        text14: "Unexcused absence",
        text15: "Compensatory Work Count for Shift",
        text16: "Has Compensatory Schedule for Shift: ",
        text17: "but the employee did not work",
        text18: "Notes",
        text19: "Attendance updated directly",
        text20: "Do you want to remove direct attendance and recalculate?",
        text21: "Location:",
        text22: "Time:",
        text23: "Reason:",
        text24: "Late arrival:",
        text25: "Early departure:",
        text26: "Shift:",
        text27: "Details",
        text28: "Late/Early leave request",
        text29: "Leave shift:",
        text30: "Work will be credited to the corresponding compensatory day",
        text31: "Working hours",
        text32: "Night shift:",
        text33: "Day shift:",
        text34: "Fingerprint record:",
        text35: "Calculated work hours:",
        text36: "Calculated compensatory hours:",
        text37: "Overtime considered for compensatory leave",
        text38: "Leave from",
        text39: "To",
        text40: " - Registered compensatory work day",
        text41: "No Requests Found",
        text42: "Unexcused absence",
        text43: "Penalty for unexcused absence",
        text44: "Work deduction for unexcused absence",
        text45: "Late arrival penalty:",
        text46: "Early departure penalty:",
        text47: "Unexcused absence penalty:",
        text48: "penalty for Missing Check-in/out:",
        text49: "Times Missed Check-in/out:",
        text50: "Work deduction for unexcused Absence:",
        text51: "Work deduction for Late arrival:",
        text52: "Work deduction for Early departure:",
        text53: "Work deduction for Missing check-in/out:",
        text54: "No penalty",
        text55: "No records found",
        text56: "1. Available shift suggestions:",
        text57: "There are {{number}} approved shifts. Including:",
        text58: "Available shifts",
        text59: "Actual working hours",
        text60: "2. Calculated shift:",
        text61: "+ Work units:",
        text62: "+ Work hours:",
        text63: "1. Available shift suggestions:",
        text64: "No shifts found",
        text65: "Recalculating attendance",
        text66: "Work hours list",
        text67: "Leave tracking board",
        text68: "Attendance closure",
        text69: "Work Hours (Leave Symbols)",
        text70: "Export shift attendance",
        text71: "Export shift Work Hours",
        text72: "Export overtime attendance",
        text73: "Export overtime hours",
        text74: "Export overtime & extra hours",
        text75: "Export all",
        text76: "Summary",
        text77: "Requests",
        text78: "Attendance History",
        text79: "Penalties",
        text80: "Attendance calculation progress",
        text81: "Export all selected fields",
        text82: "Import fingerprint records",
        text83: "Import daily Attendance",
        text84: "Import fingerprint records (Timekeeping device)",
        text85: "Export Attendance (Including Leave Symbols)",
        text86: "Time",
        text87: "Type",
        text88: "Time is a required field!",
        text89: "Manual attendance entry",
        text90:
          "Fingerprint record successfully updated, recalculating attendance",
        text91: "Employee fingerprint record - ",
        text92: "Date is a required field!",

        maNv: "Employee id",
        hoTen: "Full name",
        company: "Company",
        branch: "Branch",
        dayOfMonth: "Day of the month",
        late: "Late arrival",
        soon: "Early departure",
        noCheckInout: "Missed check-in/out",
        noReason: "Unexcused absence",
        leave: "Leave",
        congca: "Shift work",
        overtime: "Overtime",
        ot: "Extra Hours",
        congan: "Paid Work",
        congchuan: "Standard work",
        shiftTotal: "Total work",
        day: "Day",
      },
      timesheetViewport: {
        text1: "Manual",
        text2: "Automatic work",
        text3: "Holiday",
        text4: "Leave",
        text5: "Not recorded",
        text6: "Company-wide timesheet",
        text7: "Working",
        text8: "Off",
        text9: "Automatic",
        text10: "Updating attendance data",
        text11: "Work shift",
        text12: "Recalculate work cycle",
        text13: "Manage display Column List",
        text14: "Search available Columns",
        text15: "Available column List",
        text16: "Displayed column List",
        text17: "Shift Schedule",
        text18: "Attendance time",
        text19: "Close attendance",
        text20: "Company-wide timesheet",
        text21: "Department timesheet",
        text22: "Data updated successfully",
        text23: "Saturday",
        text24: "Monday",
        text25: "Tuesday",
        text26: "Wednesday",
        text27: "Thursday",
        text28: "Friday",
        text29: "Sunday",
        text30: "Total workdays",

        mon: "Monday",
        Tue: "Tuesday",
        Wed: "Wednesday",
        Thu: "Thursday",
        Fri: "Friday",
        Sat: "Saturday",
        Sun: "Sunday",

        Mo: "Mo",
        Tu: "Tu",
        We: "We",
        Th: "Th",
        Fr: "Fr",
        Sa: "Sa",
        Su: "Su",

        text31: "Last Week",
        text32: "Total Hours",
        text33: "Shift assignment",
        text34: "Timekeeping",
        text35: "Late arrival (min)",
        text36: "Early leave (min)",
        text37: "Overtime",
        text38: "Employee",
        text39: "By week",
        text40: "By Cycle",
        text41: "By Day",
        text42: "View by day",
        text43: "View by week",
        text44: "View by cycle",
        text45: "No Work cycle Found",
        text46: "Enter content",
        text47: "Close",
        text48: "Switch to work table",
        text49: "Switch to shift table",
        text50: "Recalculate work table",
        text51: "Edit display columns",
        text52: "Confirm attendance",
        text53: "Are you sure you want to confirm attendance?",
        text54: "Confirm request",
        text55: "Are you sure you want to confirm the request?",
        text56: "Are you sure you want to undo attendance confirmation?",
        text57: "Are you sure you want to undo request confirmation?",
        text58: "Confirm attendance",
        text59: "Undo attendance confirmation",
        text60: "Confirm request",
        text61: "Undo request confirmation",
        text62: "Undo confirmation",
        text63: "Export work attendance (including leave symbols)",
        text64: "Export all",
        exportByField: "File_attendance_by_field",
        text65: "Select fields to export",
        text66: "Export work attendance",
        text67: "Export working hours (including leave symbols)",
        text68: "Export working hours",
        text69: "Shift work attendance",

        fileOvertimeWork: "Export overtime work",
        fileOvertimeHour: "Export overtime hours",
        fileHourOvertime: "Export overtime and extra hours",
        fileCheckIn: "Export fingerprint attendance data",
        fileLeave: "Export leave tracking table",
        fileApplication: "Export request tracking table",
        fileListHour: "List hour work",
        fileExportByEmployee: "File_attendance",

        text70: "File_shift_working_hours",
        text71: "File_overtime_work",
        text72: "File_overtime_hours",
        text73: "File_overtime_and_extra_hours",
        text77: "File_work_hours_list",
        text78: "File_leave_tracking_table",
        text79: "File_request_tracking_table",
        text80: "File_attendance",
        text81: "File_fingerprint_attendance",
        text82: "File_working_hours_including_leave_symbols",
        text83: "File_shift_work_attendance",
        text84: "File_shift_working_hours",
        text85: "File_overtime_work",
        text86: "File_overtime_hours",
        text87: "File_overtime_and_extra_hours",
        text88: "File_attendance_all",
        cancelText: "No",
      },
      salary: {
        payrollCustom: "List payroll custom",
        payrollPeriodEndDate: "End date",
        payrollPeriodStartDate: "Start date",
        salaryName: "Payroll name",
        salaryNameRequire: "Salary table name is a required field!",
        dateRange: "Date range",
        dateRangeSelect: "Please select a date range!",
        salaryConfig: "Salary configuration",
        salaryConfigSelect: "Select salary configuration",
        salaryConfigRequire: "Please select a salary configuration!",
        dateRangeExceed: "The date range should not exceed 60 days.",
        addPayrollCustom: "Create a new salary slip for a date range",
        importSuccessPayroll: "Successfully imported payroll data directly.",
        importFailPayroll:
          "Import failed because all rows contain payroll data errors.",
        downloadFileLabel: "Download file",
        fileExportByEmployee: "File_payslip",
        fileNameExample: "File_payroll_slip_template",
        importFile: "Import File",
        importDataFieldFileName: "File_payroll_import_template.xlsx",
        here: "here",
        compareDesc:
          "<b>The system</b> will automatically match the <b>payroll data fields</b> with the <b>corresponding information columns</b> in the <b>Excel file</b>. To ensure <b>accurate mapping</b>, please name the <b>columns in the Excel file</b> the same as the <b>data fields</b> in the system and keep the first row as the header. Alternatively, you can download the sample file",
        mappingConfigIp:
          "Do you want to use the previously saved mapping configuration?",
        fileBlank: "The file has no data",
        isExcel: " is not an Excel file",
        importDataField: "Import payroll data fields",
        employeeCodeNotFound: "Employee code not found",
        failure: "Failure",
        viewDetails: "Click to view details",
        importSuccess: "Import successful",
        duration: "Duration",
        assignee: "Assignee",
        start: "Start",
        end: "End",
        second: "second",
        completed: "Completed",
        submitForWorkflow: "Submit for Workflow",
        editablePayroll: "Editing payroll in progress",
        notification: "Notification",
        updatePayroll: "Recalculate payroll ",
        updatingPayroll: "Recalculating payroll!",
        updatePayrollSuccess: "Payroll update successful!",
        exportBatchMoney: "Export batch money transfer file",
        transferMoney: "Transfer money",
        processTransferMoney: "Update the progress of money transfer ",
        lastUpdate: "The data was last updated on ",
        tooltipImport: "This column requires data from the file",
        sendToWorkFlow: "The payroll has been submitted to the workflow.",
        downloadFile: "Download template file",
        downloadingTemplate: "Downloading template file",
        downloadTemplate:
          "Please download the template file and fill in the information as instructed to ensure successful payroll slip creation.",
        inputData: " Input Data",
        nonCurrency: "Non-currency",
        currency: "Currency",
        math: "Math",
        compare: "Compare",
        arrayString: "Array of strings",
        copy: "Keyword copied!",
        copyEmpty: "Enter a keyword to copy!",
        keyColumnMin2: "The string must have at least 2 characters!",
        keyContainSpecialChar:
          "The string must not contain special characters!",
        keyContainExcelReference:
          "The string must not duplicate the Excel reference keyword!",
        text1: "Finalize completely",
        text2: "Send salary notification",
        text3: "Import payroll slip template",
        text4: "Download payroll slip template",
        text5: "Payroll slip",
        text6: "Send salary notification:",
        text7: "Payroll slip title",
        text8: "Enter payroll slip title",
        text9: "Payroll slip content",
        text10: "The payroll slip content can be text or HTML formatted",
        text11:
          "If this box is checked, employees will receive the salary table generated by the system",
        text12: "Add payroll slip to email content",
        text13: "Attach payroll slip file to email",
        text14: "Uploaded file size should not exceed 4MB!",
        text15: "Click here",
        text16: "or drag and drop files to attach to the notification email",
        text17: "Uploaded files should not exceed 4MB",
        text18: "Update salary payment information",
        text19: "Update for all employees",
        text20: "Payment progress for all employees",
        text21:
          "You can enter payment progress for all employees or the system will calculate when you input the data for each employee or department",
        text22: "Amount",
        text23: "Applicable position",
        text24: "Applicable department",
        text25: "Enter the amount transferred for all employees",
        text26: "All",
        text27: "Employee",
        text28: "Transferred amount",
        text29: "Payment progress",
        text30: "Enter transferred amount",
        text31: "Employee name",
        text32: "Total amount",
        text33: "Transferred amount",
        text34: "Payment progress",
        text35: "Select all",
        text36: "Select all employees with unpaid salary",
        text37: "Deselect all",
        text38: "Update salary payment information",
        text39: "Update salary payment status",
        text40: "employee",
        text41: "Payment progress of the payroll slip:",
        text42: "Payment progress for",
        text43:
          "You can enter payment progress for selected employees or the system will calculate when you enter the total transferred amount",
        text44: "Enter transferred amount",
        text45: "Transferred amount",
        text46: "Payroll slip does not contain employees",
        text47: "Sent",
        text48: "Sending failed",
        text49: "Not sent",
        text50: "Employee code",
        text51: "Employee name",
        text52: "Status",
        text53: "No employees with status",
        text54: "Payroll slip does not contain employees",
        text55: "Search employee",
        text56: "Import payroll slip",
        text57:
          "Note: Select corresponding data fields from the Excel file to perform bulk import",
        text58: "Attach .xlsx Excel file",
        text59: "Payroll slip name",
        text60: "Enter payroll slip name",
        text61: "Payroll slip",
        text62: "Month to import",
        text63: "Select month",
        text64: "Payroll slip configuration",
        text65: "Header row",
        text66: "Enter header row",
        text67: "Data starts from row",
        text68: "Enter data starting from row",
        text69: "To row",
        text70: "Last row",
        text71: "Data field",
        text72: "Column",
        text73: "Note:",
        text74: "+ Data field ",
        text75: "Employee profile code, Full name, Total amount",
        text76: "must be selected.",
        text77:
          "+ Columns of the imported file that do not match the selected data fields will be auto-generated by the system",
        text78:
          "Cannot import because payroll slip configuration does not contain Import column",
        text79: "When splitting employee rows",
        text80: "Import into all rows",
        text81: "Import into the first row",
        text82: "Import into the last row",
        text83: "Payroll slip import history",
        text84: "Order",
        text85: "Result",
        text86: "Import history details",
        text87: "Update successful",
        text88: "This action will recalculate the salary for the employees",
        text89: "Recalculate",
        text90: "Add update note for this cell",
        text91: "Note",
        text92: "Export payroll slip file for this employee",
        text93: "Export file",
        text94: "Delete employee from payroll slip",
        text95: "Delete employee",
        text96: "Add note successful",
        text97: "Note - ",
        text98: "Note content",
        text99: "Allow employees to view this note in their payroll slip",
        text100: "Payroll slip updated successfully",
        text101: "Common payment template",
        text102: "BIDV bank template",
        text103: "MB bank template",
        text104: "ViettinBank bank template",
        text105: "Export payroll slip details",
        text106: "Export payroll slip details with formula",
        text107: "Common payment template",
        text108: "BIDV bank template",
        text109: "MB bank template",
        text110: "ViettinBank bank template",
        text111: "Import field values",
        text112: "Update salary payment status",
        text113: "Salary payment",
        text114: "Send salary notification",
        text115: "Finalize completely",
        text116: "Close",
        text117: "Assignee",
        text118: "Execution time",
        text119: "Details",
        text120: "Payroll slip has no transaction history",
        text121: "Allow employees to view this note",
        text122: "Payroll slip",
        text123: "Transaction history",
        text124: "Payroll slip template",
        text125: "Recalculating",
        text126:
          "To update the latest data for employees in the payroll slip, recalculate the employee’s attendance for the corresponding month.",
        text127: "Are you sure you want to perform this action?",
        text128: "Start",
        text129: "Success",
        text130: "Status",
        text131: "Progress",
        text132: "Assignee",
        text133: "Payroll list",
        text134: "Import Payroll",
        text135: "Import payroll template",
        text136: "View payroll slip import history",
        text137: "Download payroll slip template",
        text138: "Direct import",
        text139: "Main payroll slip",
        text140: "Created by",
        text141: "Payroll slip name",
        text142: "Status",
        text143: "Applicable department",
        text144: "Applicable position",
        text145: "Total employees",
        text146: "Total amount",
        text147: "Creation date",
        text148: "Are you sure you want to delete payroll slip ",
        text149: "Upload payroll slip template",
        text150: "Total rows",
        text151: "Minimum value of rows",
        text152: "Maximum value of rows",
        text153: "Last row value",
        text154: "Average value of rows",
        text155: "Formula",
        text156: "Sum of row values",
        text157: "Minimum value of rows",
        text158: "Maximum value of rows",
        text159: "Average value of rows",
        text160: "Payroll slip configuration details",
        text161: "Configure columns",
        text162: "Create new payroll slip configuration",
        text163: "Update payroll slip configuration",
        text164: "All positions",
        text165:
          "On this date every month, the system will automatically generate the payroll slip of the previous month based on this configuration",
        text166:
          "If you select a date earlier than the 15th, it will automatically create the payroll slip for the previous month. If you select a date later than or equal to the 15th, it will create the payroll slip for the current month. If you select a date later than the last day of the month, the selected date will be the last day of the month.",
        text167: "Serial number",
        text168: "Get data from import",
        text169: "Formula",
        text170: "Constant",
        text171: "CALCULATION",
        text172: "KEYWORDS",
        text173: "Automatic keywords with values calculated or predefined",
        text174: "No data",
        text175: "Payroll slip creation successful",
        text176:
          "Payroll slip creation is in progress, this process may take a few minutes. You can wait on this page or return when you get the completion notification.",
        text177: "Payroll slip configuration list",
        text178: "Create payroll slip",
        text179: "Payroll Configuration List",
        text180: "Create Payroll",
        text181: "Select the month to create payroll",
        text182: "Leave settings",
        text183: "January next year",
        text184: "February next year",
        text185: "March next year",
        text186: "April next year",
        text187: "May next year",
        text188: "June next year",
        text189: "July next year",
        text190: "August next year",
        text191: "September next year",
        text192: "October next year",
        text193: "November next year",
        text194: "December next year",
        text195: "Custom date",
        text196: "No accumulation",
        text197: "Remaining leave days of the year",
        text198: "Remaining leave days of half-year",
        text199: "Remaining leave days of the quarter",
        text200: "Custom",
        text202: "All departments",
        text203: "Compensatory Leave Management",
        text204: "Are you sure you want to finalize the payroll slip?",
        text205: "Are you sure you want to close the payroll slip?",
        text206: "Payroll slip import history details",
        text207: "Column",
        text208: "Column is a required field!",
        text209: "Data field is a required field!",
        text210: "Payroll slip name is a required field!\n",
        text211:
          "Selecting the month to create the payroll slip is a required field!",
        text212: "Enter note",
        text213: "Supplementary payroll slip",
        payrollCreate:
          "The payroll for {{month}} has been created. Do you want to recalculate the payroll?",
      },
      timekeeping: {
        afterCheckIn: "After check-in",
        roundingMinutePlaceholder: "30 (minutes)",
        text1: "Shift code is a required field!",
        text2: "Shift name is a required field!",
        text3: "Start time is a required field!",
        text4: "End time is a required field!",
        text5: "Overnight is a required field!",
        text6:
          "Flexible hours are defined as the period when employees are allowed to clock in later than the scheduled shift time.",
        text7: "Apply",
        text8: "Before check-in",
        text9: "Both",
        text10:
          "This is the time window used to limit employees' check-in/check-out times. For example, if the shift starts at 08:00 and the check-in window is set to 02:00 (2 hours), employees can clock in from 06:00. If employees clock in earlier than the 2-hour window (before 06:00), the system will not record that time.",
        text11: "Select department",
        text12: "Select position",
        text13: "Select job title",
        text14:
          "When this setting is enabled, employees in the selected shift do not need to clock in and still have full attendance recorded.",
        text15: "Position is a required field!",
        text16: "Not accepted",
        text17: "Automatic calculation",
        text18: "Calculated based on overtime",
        text19:
          "This is the time window used to limit the check-in/check-out time between shifts for employees.",
        text20: "Timekeeping settings",
        text21: "Retrieve by employee code",
        text22: "Enter Timekeeping code",
        text23: "Attendance by shift",
        text24: "Hours by shift",
        text25: "No rounding",
        text26: "Minutes of lateness rounded to attendance",
        text27:
          "Example: If the setting is 30 minutes, then when an employee is late within 0-30 minutes, provided they work the remaining hours of the day, they will be considered as having full attendance.",
        text28: "Minutes of early departure rounded to attendance",
        text29:
          "Example: If the setting is 30 minutes, then when an employee leaves early within 0-30 minutes, provided they work the remaining hours of the day, they will be considered as having full attendance.",
        text30: "Not allowed",
        text31: "Advance allowed",
        text32: "Manual",
        text33: "Automatic",
        text34:
          "The day for automatic attendance closure after the number of workdays is",
        text35:
          "If you select automatic closure, choose the date when you want to finalize.",
        text36: "Value is a required field!",
        text37: "Month",
        text38: "Overtime",
        text39: "Absence request form",
        text40: "Business trip request form",
        text41: "Fingerprint closure",
        text42: "Number of days in the attendance table excluding Sundays",
        text43:
          "Number of days in the attendance table excluding Saturdays and Sundays",
        text44:
          "Number of days in the attendance table excluding half Saturdays and Sundays",
        text45:
          "Number of days in the attendance table excluding Sundays and n days",
        text46: "Total number of shifts assigned in the attendance table",
        text47:
          "Total number of days in the attendance table excluding weekly off days",
        text48: "Number of days in the month excluding Sundays",
        text49: "Number of days in the month excluding Saturdays and Sundays",
        text50: "Number of days in the month excluding Sundays at the end",
        text51:
          "Number of days in the month excluding Saturdays and Sundays at the end",
        text52: "Custom",
        text53: "Clear selections",
        text54: "General settings",
        text55: "Attendance formula",
        text56: "Quick creation",
        text57: "Personal information",
        text58: "Monthly leave information",
        text59: "Annual leave information",
        text60: "Working",
        text61: "Leave",
        text62: "Annual leave information",
        text63: "Enter shift code",
        text64: "Enter shift name",
        text65: "Are you sure you want to delete this shift {{name}} ?",
        text66: "?",
        text67: "Leave settings",
        text68: "Leave list",
        text69: "Add new leave",
        text70: "Update leave: ",
        text71: "Shift code can only be up to 100 characters",
        text72: "Shift name can only be up to 100 characters",
        text73: "Change is a required field!",
        text74: "Table is a required field!",
        text75: "Column/Cell name is a required field!",
        text76: "Keyword is a required field!",
        text77: "Formula/Value is a required field!",
        text78: "Start time must be earlier than end time",
        text79: "Recalculating attendance",
      },
      common: {
        requireMessage: "is a required field!",
        employee: "Employee",
        department: "Department",
        position: "Position",
        title: "Job title",
        text1: "Enter the person performing the task",
        text2: "Not found",
        text3: "Please change the keyword and try again",
        text4: "Select department, branch",
        text5: "Timekeeping settings",
        text6: "Attendance formula",
        text7: "Work shift settings",
        text8: "Leave settings",
        text9: "Timekeeping",
        text10: "Assign work shifts",
        text11: "Automatic timekeeping",
        text12: "Shift registration",
        text13: "Leave management",
        text14: "Leave management",
        text15: "Payroll",
        payrollCustom: "Payroll custom",
        text16: "Payroll type",
        text17: "Payroll configuration",
        text18: "Personal page",
        text19: "My process",
        text20: "Help and Support Chat",
        text21: "Change email",
        text22: "Change password",
        text23: "Terms of use",
        text24: "Log out",
        text25: "Search",
        text26: "Dashboard",
        text27: "View instructions",
        text28: "Support chat",
        text29: "Report",
      },
      objectAssign: {
        placeholder: "Select the applicable object",
        allMember: "All departments, positions, job titles, employees",
        notFound: "Not found",
        tryAgain: "Please change the keyword and try again",
        all: "All",
        department: "Department",
        jobTitle: "Job Title",
        jobPosition: "Position",
        employee: "Employee",
      },
    },
    button: {
      create: "Create",
      update: "Update",
      delete: "Delete",
      cancelText: "Cancel",
      edit: "Edit",
      back: "Back",
      no: " ?",
      confirm: "Confirm",
      cancel: "Cancel",
      history: "History",
      confirmRemove: "Are you sure you want to delete ",
      messageUpdate: "Updated successfully!",
      lock: "Lock",
      unLock: "Unlock",
      recalculate: "Recalculate",
    },
    timesheet: {
      column: {
        employeeCode: "Employee Code",
        fullName: "Full Name",
        totalWorkDay: "Total Workdays",
        totalWorkHour: "Total Hours",
        totalWorkHourReality: "Actual Total Hours",
        standardPoints: "Standard Workdays",
        totalWorkDayShift: "Shift Workdays",
        totalWorkHoliday: "Holiday Workdays",
        totalWorkMission: "Business Trip Workdays",
        annualLeave: "Annual Leave (Start)",
        annualLeaveTotalUsed: "Annual Leave Used",
        leaveP: "Paid Leave",
        leaveNoReason: "Unpaid Leave",
        annualLeaveTotalRemain: "Remaining Leave",
        lateInMinute: "Late Arrival (mins)",
        lateInFrequency: "Late Arrival Count",
        latePenalty: "Late Penalty",
        lateWorkday: "Late Deduction (Workdays)",
        earlyOutMinute: "Early Leave (mins)",
        earlyFrequency: "Early Leave Count",
        earlyOutPenalty: "Early Leave Penalty",
        earlyOutWorkday: "Early Leave Deduction (Workdays)",
        noCheckInOutMoney: "Missed Check-In Penalty",
        noCheckInOutWorkday: "Missed Check-In Deduction (Workdays)",
        leaveWithoutReasonMoney: "Unexcused Absence Penalty",
        leaveWithoutReasonWorkDay: "Unexcused Absence Deduction (Workdays)",
        compensatoryLeaveTotalUsed: "Compensatory Leave Used",
        overtimeTotalHour: "Overtime (Hours)",
        overtimeTotalWorkDay: "Overtime (Workdays)",
      },
    },
    setting: {
      settingGps: "GPS Attendance Settings",
      gpsAction: "Add New Location",
      locationList: "Attendance Location List",
      deleteLocation: "Delete Location",
      name: "Name",
      radiusRange: "Radius Range",
      checkInLocation: "Check-in Location",
      description: "Description",
      status: "Status",
      disableGps: "GPS Check-in is disabled",
      enableGps:
        "GPS Check-in is disabled. Do you want to enable location check-in at {{name}} ? This will automatically activate GPS check-in settings.",
      addLocation: "Add new check-in location",
      updateLocation: "Update check-in location",
      nameLabel: "Location name",
      nameLabelRequire: "Location name is required!",
      descriptionPlaceholder: "Enter description here",
      objectAssignHolder:
        "Select employee or departments allowed to check in via GPS",
      objectAssignText: "Select assigned ",
      address: "Check-in location",
      limitRequest: "Daily map load limit reached",
      boundingType: "Check-in range",
      boundingBox: "Geographical boundary",
      province: "Province/City",
      district: "District",
      communes: "Ward/Commune/Town",
      radiusToolTip:
        "The allowed check-in radius for this location, default is 250m",
      valueRadius: "Radius value",
      selectBoundingType: "Select geographical boundary",
      selectBoundingTypeToolTip:
        "The system will check if the check-in coordinates are within the {{name}} of the check-in location.",
      searchLimit: "Daily request limit reached!",
      errorSearch:
        "An error occurred while communicating with the server, please try again later.",
      searchAddressPlaceholder: "Enter a keyword to search for a location.",
      enable: "Enable",
      disable: "Disable",
      endOfMonth: "End of the month",
      startOfMonth: "Start of the month",
      enough: "When the required number of working days in the month is met",
    },
  },
};
